export default "__VITE_PUBLIC_ASSET__a31bd73d__"